<a routerLink="/" target="_blank" class="mr-20 mt-5">
    @if (!appSession.tenant || !appSession.tenant.logoId) {
        <img [src]="defaultLogo" alt="logo" height="38" />
    }
    @if (appSession.tenant && appSession.tenant.logoId) {
        <img
            [src]="
                remoteServiceBaseUrl +
                '/TenantCustomization/GetTenantLogo?skin=' +
                currentTheme.baseSettings.menu.asideSkin +
                '&tenantId=' +
                appSession.tenant.id +
                '&id=' +
                appSession.tenant.logoId
            "
            alt="logo"
            height="38"
        />
    }
</a>
